module.exports = __webpack_public_path__ + "static/icon_color_bike-e543424f66ba2f4414765caa6d66cb57.png";